import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { COPY } from "@/config/copy";

export default function Landing({ onStart }) {
  const c = COPY.landing;
  const b = COPY.brand;
  return (
    <div className="relative z-10 min-h-screen flex flex-col">
      {/* Top bar — stays fixed at top */}
      <div className="flex items-center justify-between px-6 md:px-12 py-5 border-b border-[#E5E5E5]">
        <div className="section-label">{b.audit_label}</div>
        <div className="section-label hidden md:block">{b.audit_tagline}</div>
      </div>

      {/* Middle content — vertically centered in remaining viewport space */}
      <div className="flex-1 flex flex-col justify-center py-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.2, 0.8, 0.2, 1] }}
          className="stage"
        >
          <div className="section-label mb-4">{c.eyebrow}</div>

          <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-[52px] leading-[1.05] tracking-tight font-light display-tight">
            {c.headline}
          </h1>

          <p className="mt-5 mx-auto max-w-2xl text-[13px] md:text-[14px] text-[#444] leading-[1.6]">
            {c.subhead}
          </p>

          <div className="mt-6 flex flex-col items-center gap-3">
            <button className="btn-primary" data-testid="start-assessment-btn" onClick={onStart}>
              {c.cta}
              <ArrowRight className="btn-arrow" size={16} strokeWidth={1.5} />
            </button>
            <div className="section-label">{c.meta}</div>
          </div>
        </motion.div>

        {/* Why this exists — label left of the 3-box grid */}
        <div className="mt-20 md:mt-24">
          <div className="max-w-6xl mx-auto px-6 md:px-12">
            <div className="flex flex-col md:flex-row md:items-start md:gap-8">
              <div className="section-label md:pt-4 md:w-32 md:shrink-0 mb-4 md:mb-0">
                {c.value_props_label}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border border-[#E5E5E5] flex-1">
                {c.value_props.map((v, i) => (
                  <motion.div
                    key={v.n}
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.06 }}
                    className={`p-5 md:p-6 text-left ${
                      i < c.value_props.length - 1
                        ? "border-b md:border-b-0 md:border-r border-[#E5E5E5]"
                        : ""
                    }`}
                  >
                    <div className="font-serif italic text-lg md:text-xl mb-2 text-[#9fa5a3]">{v.n}</div>
                    <div className="font-serif text-base md:text-lg mb-2 leading-[1.2] font-normal display-tight">
                      {v.title}
                    </div>
                    <div className="text-[12.5px] md:text-[13px] text-[#555] leading-[1.55]">{v.body}</div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
